module.exports = __webpack_public_path__ + "assets/images/intro/covid-hits-home-scrollyimage1.jpg?v=1bc3546d";